import { ApiClient, getApi } from './api/client.js';
import { Validation } from './utils/validation.js';
import { DateUtils } from './utils/date.js';
import { Notify } from './utils/notify.js';

declare global {
  interface Window {
    API_URL: string;
    USER: {
      id: string;
      email: string;
      role: string;
      profile: Record<string, unknown>;
    } | null;
    API: ApiClient;
    Notify: typeof Notify;
    Validation: typeof Validation;
    DateUtils: typeof DateUtils;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const api = getApi();

  const token = document.cookie.match(/token=([^;]+)/)?.[1] ?? null;
  api.setToken(token);

  window.API = api;
  window.Notify = Notify;
  window.Validation = Validation;
  window.DateUtils = DateUtils;

  console.log('ILK App initialized');
  console.log('API URL:', window.API_URL);
  console.log('User:', window.USER);
});
